import { MoreVerticalIcon, PencilIcon, TrashIcon } from 'lucide-react';
import type React from 'react';

import { AgentChatWorkspace } from '@/services/types/agent-chat-workspace-types';

import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
} from '../ui/catalyst/dropdown';

interface WorkspaceListItemProps {
  workspace: AgentChatWorkspace;
  onRename: () => void;
  onDelete: () => void;
}

export const WorkspaceListItem = ({
  workspace,
  onRename,
  onDelete,
}: WorkspaceListItemProps) => {
  return (
    <>
      <span className="flex-1 truncate text-sm text-gray-900">
        {workspace.name}
      </span>
      {/* Empty span to fill slot */}
      <span />

      {/* Actions menu */}
      <Dropdown>
        <DropdownButton
          outline
          className="border-none p-0! hover:text-black! text-gray-400! rounded"
          onClick={(e: React.MouseEvent) => e.stopPropagation()}
        >
          <MoreVerticalIcon className="h-4 w-4" />
        </DropdownButton>
        <DropdownMenu anchor="right" className="z-20 min-w-28">
          <DropdownItem
            className="flex items-center gap-2"
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              onRename();
            }}
          >
            <PencilIcon className="h-3 w-3" />
            Rename
          </DropdownItem>
          <DropdownItem
            className="flex items-center gap-2"
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            <TrashIcon className="h-3 w-3 text-red-500" />
            <span className="text-red-600">Delete</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </>
  );
};
